import { styled } from "@mui/material/styles";

export const ListItem = styled("li")(({ theme }) => ({
    color: theme.palette.text.secondary,
}));
